export default {
  SET_WP_SITES: function (state, payload) {
    state.wpSites = payload;
  }
}
